export default __webpack_public_path__ + "static/Shingle-Recycling-1689829d15c43e0e9d69acb3cd4ae4e9.jpg";